// extracted by mini-css-extract-plugin
export default {"row":"LayoutView_row__IGjB7"};